import React, { useState } from 'react'

const parse = (value, fallback) => (typeof value === 'string' ? JSON.parse(value) : (value || fallback))

// Group dropdown on the event form. When the chosen group has no image and
// this event has one, offers (unticked) to give the group this event's image.
const EventGroupSelect = ({ groups: groupsJson, selectedId, eventHasImage }) => {
  const groups = parse(groupsJson, [])
  const [selected, setSelected] = useState(selectedId ? String(selectedId) : '')
  const [adopt, setAdopt] = useState(false)

  const group = groups.find(g => String(g.id) === selected)
  const offerImage = Boolean(group && !group.has_image && String(eventHasImage) === 'true')

  return (
    <div>
      <div className='flex items-center gap-3'>
        <select
          name='event[event_group_id]'
          id='event_event_group_id'
          value={selected}
          onChange={(e) => { setSelected(e.target.value); setAdopt(false) }}
          className='mt-1 block w-full h-10 px-3 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm'
        >
          <option value=''>None</option>
          {groups.map(g => (
            <option key={g.id} value={String(g.id)}>{g.name}</option>
          ))}
        </select>
        {group && (
          <a href={group.edit_url} className='shrink-0 text-xs text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300'>
            Edit group
          </a>
        )}
      </div>

      {offerImage && (
        <label className='mt-2 flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 cursor-pointer'>
          <input type='hidden' name='event[adopt_image_for_group]' value='0' />
          <input
            type='checkbox'
            name='event[adopt_image_for_group]'
            value='1'
            checked={adopt}
            onChange={(e) => setAdopt(e.target.checked)}
            className='rounded border-gray-300 dark:border-gray-600 text-blue-600 focus:ring-blue-500'
          />
          Use this event's image for the group ({group.name} has no image yet)
        </label>
      )}
    </div>
  )
}

export default EventGroupSelect
